define.alias("shared/components/shared/sourceless-trial/confirmation-modal", "calendar/components/shared/sourceless-trial/confirmation-modal");